import './index.css';
import * as React from 'react';

export const PopupViewAnimation = ({
  // 子组件
  children,
  // mask样式
  style = {},
  // 是否允许蒙层响应点击
  allowMaskClick = true,
  type = 'view',
  onShow = () => {},
  onClose = () => {},
  onMask = () => {},
}) => {
  const [contentHeight, setContentHeight] = React.useState(0);
  const [isShowAnimation, setIsShowAnimation] = React.useState(false);
  const [isHideAnimation, setIsHideAnimation] = React.useState(false);
  const [isFinishAnimation, setIsFinishAnimation] = React.useState(false);
  const maskRef: any = React.useRef();
  const contentRef: any = React.useRef();
  let backPressListenerId = null;

  React.useEffect(() => {
    addBackPressListener();
    return () => {
      removeBackPressListener();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maskRef, contentRef, contentHeight, backPressListenerId]);

  const BackPressModule = Mach.requireModule('BackPressModule');
  /**
     * 安卓端点击返回按钮监听
     */
  const addBackPressListener = () => {
    backPressListenerId = BackPressModule.addBackPressListener?.(() => {
      // 返回true时会阻止事件冒泡传递，因而不会执行默认的后退行为
      // 返回false时会使事件继续传递，触发其他注册的监听函数，或是系统默认的后退行为
      hideAnimation();
      return true;
    });
  };

  /**
     * 移除返回监听
     */
  const removeBackPressListener = () => {
    if (backPressListenerId) {
      BackPressModule?.removeBackPressListener(backPressListenerId);
    }
  };

  let originOnClose = () => {};
  // 展示动画
  const showAnimation = () => {
    if (isShowAnimation) {
      return;
    }
    setIsShowAnimation(true);
    const fromValue = Mach.env.screenHeight - contentHeight;
    const animation = {
      duration: '300ms',
      keyFrames: {
        from: { transform: `translateY(${fromValue})` },
        to: { transform: 'translateY(0)' }
      },
      iterationCount: 1,
      timingFunction: 'ease-in-out',
      fillMode: 'forward',
    };
    contentRef.current?.setAnimation(animation, (res) => {
      if (res.state === 'end') {
        onShow?.();
        setIsFinishAnimation(true);
      }
    });
  };

  // 隐藏动画
  const hideAnimation = () => {
    if (isHideAnimation) {
      return;
    }
    setIsHideAnimation(true);
    const animation = {
      duration: '300ms',
      keyFrames: {
        from: { transform: 'translateY(0)' },
        to: { transform: `translateY(${contentHeight})` }
      },
      iterationCount: 1,
      timingFunction: 'ease-in-out',
      fillMode: 'forward',
    };
    contentRef.current?.setAnimation(animation, (res) => {
      if (res.state === 'end') {
        originOnClose?.();
        onClose?.();
      }
    });
    hideMaskAnimation();
  };
  let childrenComponent;
  if (React.isValidElement(children)) {
    const originProps: any = children.props;
    originOnClose = originProps?.onClose;
    // 重写子组件关闭方法
    childrenComponent = React.cloneElement<any>(children, { onClose: hideAnimation });
  }

  // 蒙层渐显
  const showMaskAnimation = () => {
    const animation = {
      duration: '300ms',
      keyFrames: {
        from: { opacity: 0 },
        to: { opacity: 1 }
      }
    };
    maskRef.current?.setAnimation(animation);
  };

  // 蒙层渐隐
  const hideMaskAnimation = () => {
    const animation = {
      duration: '300ms',
      keyFrames: {
        from: { opacity: 1 },
        to: { opacity: 0 }
      }
    };
    maskRef.current?.setAnimation(animation);
  };

  /**
     * 点击蒙层交互
     */
  const onClickMask = () => {
    if (allowMaskClick) {
      onMask?.();
      hideAnimation();
    }
  };

  const currentMaskStyle = isFinishAnimation ? { opacity: 1 } : {};
  const currentContentStyle = isFinishAnimation ? { transform: 'translateY(0)' } : { };
  const renderRootView = () => (
    <view className="root" onClick={() => {}}>
      <view
        className="mask"
        ref={maskRef}
        style={{
          ...style,
          ...currentMaskStyle
        }}
        onClick={onClickMask}
        // eslint-disable-next-line react/no-unknown-property
        onLayout={() => {
          showMaskAnimation();
        }}
      />
      <view
        className="content"
        ref={contentRef}
        style={{
          ...currentContentStyle
        }}
        // eslint-disable-next-line react/no-unknown-property
        onLayout={(event) => {
          const height = event?.detail?.height;
          setContentHeight(height);
          showAnimation();
        }}
      >
        {childrenComponent}
      </view>
    </view>
  );

  if (type === 'modal') {
    return (
      <modal>
        {renderRootView()}
      </modal>
    );
  } else {
    return renderRootView();
  }
};
